// src/components/editor/PriceText.jsx
import React from 'react';

const PriceText = ({ 
  content, 
  fontSize, 
  color, 
  fontFamily, 
  fontWeight, 
  fontStyle,
  enablePriceFormat = false,
  priceFormat = {}
}) => {
  // Paramètres par défaut
  const defaultFormat = {
    beforeEuroSize: 100,    // Taille des euros en % de la taille de base
    beforeEuroHeight: 0,    // Décalage vertical en % de la taille de base
    euroSize: 40,           // Taille du symbole € en % de la taille de base
    euroHeight: -20,        // Décalage vertical du € en % de la taille de base
    afterEuroSize: 40,      // Taille des centimes en % de la taille de base
    afterEuroHeight: -20    // Décalage vertical des centimes en % de la taille de base
  };

  const format = { ...defaultFormat, ...priceFormat };

  // Regex pour détecter le format prix : nombre + € + centimes
  const priceRegex = /(\d+)(€)(\d{2})/g;
  
  const renderPriceContent = (text) => {
    // Si le format prix n'est pas activé, rendu normal
    if (!enablePriceFormat) {
      return text;
    }

    const parts = [];
    let lastIndex = 0;
    let match;

    // Parcourir tous les matches de prix dans le texte
    while ((match = priceRegex.exec(text)) !== null) {
      // Ajouter le texte avant le prix
      if (match.index > lastIndex) {
        parts.push(
          <span key={`text-${lastIndex}`}>
            {text.slice(lastIndex, match.index)}
          </span>
        );
      }

      // Ajouter le prix formaté
      const [fullMatch, euros, euroSymbol, centimes] = match;
      parts.push(
        <span key={`price-${match.index}`} className="price-container">
          {/* Partie euros */}
          <span 
            className="price-euros"
            style={{
              fontSize: `${(fontSize * format.beforeEuroSize) / 100}px`,
              position: 'relative',
              top: `${(fontSize * format.beforeEuroHeight) / 100}px`,
              display: 'inline-block'
            }}
          >
            {euros}
          </span>
          
          {/* Symbole € */}
          <span 
            className="price-euro-symbol"
            style={{
              fontSize: `${(fontSize * format.euroSize) / 100}px`,
              position: 'relative',
              top: `${(fontSize * format.euroHeight) / 100}px`,
              display: 'inline-block',
              marginLeft: '1px'
            }}
          >
            {euroSymbol}
          </span>
          
          {/* Centimes */}
          <span 
            className="price-cents"
            style={{
              fontSize: `${(fontSize * format.afterEuroSize) / 100}px`,
              position: 'relative',
              top: `${(fontSize * format.afterEuroHeight) / 100}px`,
              display: 'inline-block'
            }}
          >
            {centimes}
          </span>
        </span>
      );

      lastIndex = match.index + fullMatch.length;
    }

    // Ajouter le reste du texte après le dernier prix
    if (lastIndex < text.length) {
      parts.push(
        <span key={`text-${lastIndex}`}>
          {text.slice(lastIndex)}
        </span>
      );
    }

    // Si aucun prix trouvé, retourner le texte normal
    return parts.length > 0 ? parts : text;
  };

  return (
    <span
      style={{
        fontSize: `${fontSize}px`,
        color,
        fontFamily,
        fontWeight: fontWeight || 'normal',
        fontStyle: fontStyle || 'normal',
        lineHeight: '1.2'
      }}
    >
      {renderPriceContent(content)}
    </span>
  );
};

export default PriceText;